'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import H2 from 'UIComponents/elements/headings/H2';
import H5 from 'UIComponents/elements/headings/H5';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { OLAF, OZ } from 'HubStyleTokens/colors';
import { ACCOUNT_SETUP_ORDER } from 'ads-account-connection/lib/AdwordsSetupStatus';
import AdwordsStepIndicators from 'ads-account-connection/components/ad-accounts/AdwordsStepIndicators';

const AdwordsAdAccountSetupComplete = ({
  onCancel,
  currentStep,
  adAccountId,
  onSelect
}) => {
  const [loading, setLoading] = useState(false);

  const handleConnectAccountClick = () => {
    setLoading(true);
    onSelect(adAccountId);
  };

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCancel
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(AdwordsStepIndicators, {
        stepIndex: ACCOUNT_SETUP_ORDER.indexOf(currentStep)
      }), /*#__PURE__*/_jsxs("div", {
        align: "center",
        className: "m-top-2",
        children: [/*#__PURE__*/_jsx(UIIconCircle, {
          name: "success",
          backgroundColor: OZ,
          borderStyle: "solid",
          borderWidth: 2,
          color: OLAF
        }), /*#__PURE__*/_jsx(H5, {
          className: "m-top-4 m-bottom-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.setupComplete"
          })
        }), /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.tooltip"
          }),
          tooltipPlacement: "right",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.setupCompleteBody"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "right",
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        use: "primary",
        loading: loading,
        onClick: handleConnectAccountClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.connectAccountButton"
        })
      })
    })]
  });
};

export default AdwordsAdAccountSetupComplete;